"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditPreselectionContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const CreditPreselectionContent_style_1 = require("./CreditPreselectionContent.style");
const CreditPreselectionContent = ({ productAmount, setSelectedProductAmount }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(CreditPreselectionContent_style_1.SliderWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.SliderCredits, { value: productAmount, onChange: value => setSelectedProductAmount(value) }) }) }));
};
exports.CreditPreselectionContent = CreditPreselectionContent;
